import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from "./Header";
import LoadingSpinner from "./LoadingSpinner";
import { fetchCategories, fetchArchivedCategories } from "../api";

// mode: 'active' | 'archived'
export default function CategoriesPage({ mode, onBack }) {
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  const title = mode === 'archived' ? 'Archived' : 'Categories';

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      setLoading(true);
      const fetcher = mode === 'archived' ? fetchArchivedCategories : fetchCategories;
      const data = await fetcher();
      const sortedData = data.sort((a, b) => b.itemsCount - a.itemsCount);
      if (!cancelled) {
        setCategories(sortedData);
        setLoading(false);
      }
    };

    load();
    return () => { cancelled = true; };
  }, [mode]);

  const handleCategorySelect = (category) => {
    navigate(
      mode === 'archived' ? `/archived/${category.id}` : `/categories/${category.id}`,
      { state: { categoryTitle: category.title } }
    );
  };

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-800">
      <Header title={title} onBack={onBack} />
      <div className="max-w-7xl mx-auto p-4 sm:p-6 lg:p-8">
        {loading ? (
          <LoadingSpinner />
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
            {categories.map((category) => (
              <button
                key={category.id}
                onClick={() => handleCategorySelect(category)}
                className="p-4 sm:p-6 bg-white dark:bg-gray-700 rounded-lg shadow-sm border border-gray-200 dark:border-gray-500 hover:shadow-md dark:hover:shadow-gray-700 transition-all duration-200 text-left hover:scale-105"
              >
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-3">
                    <span className="text-lg font-medium text-gray-800 dark:text-white">
                      {category.title}
                    </span>
                    <span className="text-sm text-gray-500 dark:text-gray-400">
                      ({category.itemsCount || 0})
                    </span>
                  </div>
                  <span className="text-gray-400">→</span>
                </div>
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}